// La sección «LIVE FEST» de la consola de agencias, la MISMA que pinta la app:
// se importan tal cual sus archivos (dejan AgenciasLiveFest* en global) y su
// hoja de estilos, así la vista previa del backoffice es lo que verá la
// agencia y el modelo (qué se guarda) no se copia aquí.
//   model.js  sanitize(), isFactory() y countdown()
//   view.js   la pantalla: rótulo, «cargando» y cuenta atrás
import '../../../renderer/tabs/agencias/livefest/model.js';
import '../../../renderer/tabs/agencias/livefest/view.js';
import '../../../renderer/styles/views/agency-live-fest.css';

export const LiveFestModel = globalThis.AgenciasLiveFestModel;
export const LiveFestView = globalThis.AgenciasLiveFestView;
